import React, {useContext} from 'react';
import classnames from 'classnames';
import {Map} from 'immutable';

import {pushQueryParams} from 'client/history';
import {Button, Card, DatePicker, Icon, WithToggle} from '@albert-io/atomic';
import {RANGES} from '@albert-io/atomic/organisms/DatePicker/DatePicker.helpers';

import moment from 'moment';

import {ReportsContext} from '../../Reports.context';

function DateFilter() {
  const {range, start, end} = useContext(ReportsContext);

  const displayRange =
    range === RANGES.CUSTOM
      ? `${moment(start).format('MMM D, YYYY')} - ${moment(end).format('MMM D, YYYY')}`
      : range;

  const value = Map({
    id: range,
    start,
    end,
    value: range
  });

  return (
    <WithToggle dismissOnEscape key='reports-filter-date'>
      {({on, onClick}) => (
        <>
          <Button as='button' variant='faded' className='u-cursor_pointer' onClick={onClick}>
            <Icon icon={['far', 'calendar-alt']} className='u-mar-r_2' />
            {displayRange}
          </Button>
          <Card
            className={classnames('reports-filter__date reports-filter__dropdown', {
              'reports-filter__dropdown--open': on,
              'reports-filter__dropdown--closed': !on
            })}
            paddingLevel={3}
            shadow='far'
          >
            <DatePicker
              excludeDates={[RANGES.ALL_TIME, RANGES.LAST_WEEK, RANGES.LAST_MONTH]}
              // eslint-disable-next-line @typescript-eslint/no-shadow
              onSubmit={({range, start, end}) => {
                pushQueryParams({
                  range,
                  start,
                  end
                });
                onClick();
              }}
              value={value}
            />
          </Card>
        </>
      )}
    </WithToggle>
  );
}

export default DateFilter;
